import { useCallback } from 'react';
import { components, OptionProps } from 'react-select';
import { OptionType } from './type';

export const Option = (props: OptionProps<OptionType>) => {
  const handleRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (props.isFocused && element) {
        element.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth',
        });
      }
    },
    [props.isFocused]
  );

  return (
    <div ref={handleRef}>
      <components.Option {...props} />
    </div>
  );
};
